import { Component } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-complete-profile-confirmation',
    templateUrl: './complete-profile-confirmation.component.html',
    styleUrls: ['./complete-profile-confirmation.component.scss'],
    standalone: false
})
export class CompleteProfileConfirmationComponent extends CfetBaseComponent {

  constructor() { super(); }

  shopNow(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      const url = environment.premierDashboard;
      this.redirectUrl(url);
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

}
